import React, { useState, useContext } from "react";
import "../../Style/actionstyle.scss";
import CustomerForm from "./CustomerForm";
import DeleteCustomer from "./DeleteCustomer";
import { MdDelete, MdModeEdit } from "react-icons/md";
import { AuthContext } from "../../Context/AuthContext";
import { translateLauguage } from "../../Function/Translate";
import { IconButton, Stack, Box, Tooltip } from "@mui/material";

export default function CustomerAction({ editData, setRefetch }) {
  // Change Language
  const { language } = useContext(AuthContext);
  const { t } = translateLauguage(language);

  //Modal update
  const [openEdit, setOpenEdit] = useState(false);
  const handleOpenEdit = () => setOpenEdit(true);
  const handleCloseEdit = () => setOpenEdit(false);

  //Modal delete
  const [openDel, setOpenDel] = useState(false);
  const handleOpenDel = () => setOpenDel(true);
  const handleCloseDel = () => setOpenDel(false);

  return (
    <div>
      <Stack direction="row" justifyContent="right">
        <Tooltip title="update customer" placement="top">
          <IconButton onClick={handleOpenEdit}>
            <Box className="update-container">
              <MdModeEdit className="update-icon" />
            </Box>
          </IconButton>
        </Tooltip>
        <Tooltip title="delete customer" placement="top">
          <IconButton onClick={handleOpenDel}>
            <Box className="delete-container">
              <MdDelete className="delete-icon" />
            </Box>
          </IconButton>
        </Tooltip>
      </Stack>

      <CustomerForm
        open={openEdit}
        title={"Update"}
        editData={editData}
        setRefetch={setRefetch}
        handleClose={handleCloseEdit}
      />
      <DeleteCustomer
        open={openDel}
        editData={editData}
        setRefetch={setRefetch}
        handleClose={handleCloseDel}
      />
    </div>
  );
}
